
import React, { useEffect, useState } from "react";
import CertificateSidebar from "./CertificateSidebar";

export default function CertificateLayout({ children }) {
  const [sidebarExpanded, setSidebarExpanded] = useState(() => {
    return (
      localStorage.getItem("certificate_sidebar_collapsed") !== "true"
    );
  });

  useEffect(() => {
    localStorage.setItem(
      "certificate_sidebar_collapsed",
      sidebarExpanded ? "false" : "true"
    );
  }, [sidebarExpanded]);

  const handleSidebarToggle = (expanded) => {
    setSidebarExpanded(Boolean(expanded));
  };

  const contentStyle = {
    marginLeft: sidebarExpanded ? "260px" : "64px",
    padding: "18px",
    minHeight: "100vh",
    background: "#faf7fb",
    boxSizing: "border-box",
    transition: "margin-left 0.22s ease",
  };

  return (
    <div style={{ minHeight: "100vh" }}>
      <CertificateSidebar
        expanded={sidebarExpanded}
        onToggle={handleSidebarToggle}
      />

      <main style={contentStyle}>{children}</main>
    </div>
  );
}
